import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router";

import { UsageReportRoute } from "../../containers/UsageReportRoute";

type UsageReportSearch = {
    id?: string;
};

export const Route = createFileRoute("/_layout-nosidebar/usageReport")({
    component: UsageReport,
    validateSearch: (search: UsageReportSearch & SearchSchemaInput): UsageReportSearch => ({
        id: search.id,
    }),
});

function UsageReport() {
    return <UsageReportRoute />;
}
